import React from 'react';
import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { PARTNER_LOGO_URLS } from 'shared/constants/assets';

import './LogoMarquee.css';

/**
 * Landing-page "trusted by leading brands" section: two rows of partner logos
 * that drift in opposite directions on an infinite loop. The logo list is
 * duplicated per row so the CSS translateX loop wraps seamlessly. Logos render
 * grayscale and lift into full color on hover. Content is static (sourced from
 * `PARTNER_LOGO_URLS`) and not wired to any backend.
 */
const LogoMarquee: React.FC = () => {
  const { t } = useTranslation();

  const logos = PARTNER_LOGO_URLS;
  if (logos.length === 0) return null;

  // Split into two visually balanced rows.
  const mid = Math.ceil(logos.length / 2);
  const rows = [logos.slice(0, mid), logos.slice(mid)];

  const renderTile = (src: string, key: string, clone: boolean) => (
    <div className="lm-tile" key={key} data-clone={clone ? 'true' : undefined}>
      <img src={src} alt="" loading="lazy" decoding="async" />
    </div>
  );

  return (
    <section className="logo-marquee" aria-label={t('welcome.partners.title') ?? 'Partners'}>
      {/* <div className="lm-head">
        <span className="lm-pill">
          <Sparkles aria-hidden="true" />
          <span>{t('welcome.partners.title')}</span>
        </span>
        <p className="lm-subtitle">{t('welcome.partners.subtitle')}</p>
      </div> */}

      <div className="lm-rows" aria-hidden="true">
        {rows.map((rowLogos, rowIndex) => {
          if (rowLogos.length === 0) return null;
          const direction = rowIndex % 2 === 0 ? 'ltr' : 'rtl';
          return (
            <div key={rowIndex} className={`lm-row lm-row--${direction}`}>
              {rowLogos.map((src, i) =>
                renderTile(src, `r${rowIndex}-a${i}`, false),
              )}
              {rowLogos.map((src, i) =>
                renderTile(src, `r${rowIndex}-b${i}`, true),
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default LogoMarquee;
